
import './sidebar.scss';
import SidebarItem from './SidebarItem';

const Sidebar = ({ data }) => {
  return (
    <div className="sidebar">
      {data?.map((item, index) => <SidebarItem key={index} item={item} />)}
    </div>
  )
}

export default Sidebar;